import Swup from 'swup';
// import SwupScriptsPlugin from '@swup/scripts-plugin/dist/SwupScriptsPlugin.min';
// import Splide from '@splidejs/splide';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import intersect from '@alpinejs/intersect';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/effect-cards';
import 'swiper/css/free-mode';

// Import Alpine components
import './components/accordion.js';
import './components/rule.js';
import './components/spacer.js';
import './components/cursorFollower.js';
import { initCarousel } from './components/swiper.js';

window.isMobile = window.matchMedia('only screen and (max-width: 760px)').matches;


const options = {
  containers: ['#swup', '#swup-actions'],
  plugins: [
    // new SwupScriptsPlugin()
  ]
};

// Register Alpine plugins before starting
Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.plugin(intersect);

// Horizontal-scrolling carousel — used by sector-carousel, newsfeed and project-related.
// Steps to the next/previous card edge, reading the track's scroll-padding so the
// snap target stays aligned with whatever gutter the active breakpoint applies.
Alpine.data('scrollCarousel', () => ({
  overflows: false,
  _ro: null,
  init() {
    this.$nextTick(() => this.check());
    if (window.ResizeObserver && this.$refs.track) {
      this._ro = new ResizeObserver(() => this.check());
      this._ro.observe(this.$refs.track);
    }
  },
  destroy() {
    if (this._ro) this._ro.disconnect();
  },
  check() {
    const t = this.$refs.track;
    if (!t) return;
    this.overflows = t.scrollWidth > t.clientWidth + 1;
  },
  scroll(dir) {
    const t = this.$refs.track;
    if (!t) return;
    const cards = [...t.children].filter(el => !el.matches('template'));
    if (!cards.length) return;

    const trackLeft = t.getBoundingClientRect().left;
    const pad = parseFloat(getComputedStyle(t).scrollPaddingLeft) || 0;
    const eps = 4; // tolerance for sub-pixel drift mid-snap

    let target;
    if (dir > 0) {
      target = cards.find(c => c.getBoundingClientRect().left - trackLeft > pad + eps);
    } else {
      target = [...cards].reverse().find(c => c.getBoundingClientRect().left - trackLeft < pad - eps);
    }

    if (!target) {
      t.scrollBy({ left: dir * t.clientWidth * 0.6, behavior: 'smooth' });
      return;
    }

    const delta = target.getBoundingClientRect().left - trackLeft - pad;
    t.scrollBy({ left: delta, behavior: 'smooth' });
  }
}));

// Header / navigation state (registered before Alpine.start)
Alpine.data('siteHeader', () => ({
  menuOpen: false,
  sectorsOpen: false,
  aboutOpen: false,
  scrolled: window.scrollY > 60,
  isMobile: window.innerWidth < 1000,

  onScroll() {
    this.scrolled = window.scrollY > 60;
  },
  onResize() {
    this.isMobile = window.innerWidth < 1000;
  },
  closeAll() {
    this.sectorsOpen = this.aboutOpen = this.menuOpen = false;
  },
  // Lock background scroll while any overlay is open
  get locked() {
    return this.sectorsOpen || this.aboutOpen || this.menuOpen;
  },
  // Solid (white) header when scrolled or a mega-menu is open
  get solid() {
    return this.scrolled || this.sectorsOpen || this.aboutOpen;
  },
  // Transparent header only at the top of a hero page with no menu open
  get transparent() {
    return !this.scrolled && !this.sectorsOpen && !this.aboutOpen;
  },
}));

// Make Alpine available globally
window.Alpine = Alpine;

// Make carousel init function globally available
window.initCarousel = initCarousel;

const swup = new Swup(options);

// Keep the <body> class in sync with the page being navigated to.
// Swup only swaps the content container, so the server-rendered body
// classes (template-*, has-hero, …) would otherwise go stale.
function syncBodyClass(visit) {
  const url = visit?.to?.url;
  const html = url && swup.cache.get(url)?.html;
  if (!html) return;
  const match = html.match(/<body[^>]*?\sclass="([^"]*)"/i);
  if (match) {
    document.body.setAttribute('class', match[1]);
  }
}

// Close any open menu BEFORE navigation begins so Alpine's x-trap.noscroll
// has a chance to release the scroll-lock cleanly before Swup swaps the DOM.
swup.hooks.on('visit:start', () => {
  const data = Alpine.$data(document.body);
  if (data?.closeAll) data.closeAll();
});

// Events
swup.hooks.on('content:replace', (visit) => {
  syncBodyClass(visit);
  // Belt-and-braces: if the focus-trap scroll-lock left inline overflow
  // styles behind on <html>/<body>, clear them so the new page can scroll.
  document.documentElement.style.overflow = '';
  document.documentElement.style.paddingRight = '';
  document.body.style.overflow = '';
  document.body.style.paddingRight = '';
  init();
});

document.addEventListener('DOMContentLoaded', () => {
  l('ready');
  // Start Alpine.js
  Alpine.start();
  // checkCookie();
  init();
});

// Functions 

// Better console.log – only for local .test urls
function l(m) {
  if (window.location.hostname.split('.').at(-1) == 'test') {
    console.log(m);
  }
}

function init() {
  l('👍');
  if (typeof window.initCarousel === 'function') {
    const carousels = document.querySelectorAll('.carousel-container:not([data-carousel-initialized])');
    carousels.forEach(function (container) {
      container.setAttribute('data-carousel-initialized', 'true');
      window.initCarousel(container);
    });
  }

  // Hero videos after a Swup navigation. Two things to fix:
  //  1. Swup inserts markup via innerHTML, which does NOT execute <script>
  //     tags — so the inline src-picker in the hero block is skipped and the
  //     <video> arrives with no src. Pick the right one here.
  //  2. iOS Safari won't auto-fetch a swapped-in <video> without an explicit
  //     .load(); autoplay also silently fails post-navigation so nudge play().
  document.querySelectorAll('.home-hero__media').forEach((el) => {
    if (el.tagName !== 'VIDEO') return;
    if (!el.src) {
      const mobile = el.dataset.srcMobile;
      const desktop = el.dataset.srcDesktop;
      const useMobile = mobile && window.matchMedia('(max-width: 768px)').matches;
      const chosen = useMobile ? mobile : desktop;
      if (chosen) el.src = chosen;
    }
    try { el.load(); } catch (e) {}
    const p = el.play();
    if (p && typeof p.catch === 'function') p.catch(() => {});
    // Belt-and-braces for the fade-in: if Alpine hasn't re-mounted the new
    // hero section yet (mutation-observer race), toggle is-loaded here too so
    // opacity: 0 doesn't hide the freshly-swapped video.
    const section = el.closest('.home-hero');
    if (section) {
      const markLoaded = () => section.classList.add('is-loaded');
      if (el.readyState >= 2) markLoaded();
      el.addEventListener('loadeddata', markLoaded, { once: true });
      el.addEventListener('canplay', markLoaded, { once: true });
    }
  });

  // Initialize functions
  // isMobile = window.matchMedia('only screen and (max-width: 782px)').matches;
  // console.log()
  // window.addEventListener('resize', () => { isMobile = window.innerWidth < 768; });
}